// ============================================================
// HandoutRevealDialog (v8.363.10) - who gets to see a handout.
//
// The audience picker is `AudienceDialog` (generic since v9.5.11); a
// handout adds "Announce in the vox", which posts the line with the
// thumbnail to the same audience, "back to a draft" for nobody, and
// "Show and present" (v9.8.0), which also opens it on their screens.
// ============================================================
import AudienceDialog from './AudienceDialog';
import type { ChatChannel, Person } from '../engine/chat';
import type { Handout, RevealTarget } from '../engine/handouts';

interface Props {
  show: boolean;
  handout: Handout | null;
  people: Person[];
  channels: ChatChannel[];
  onReveal: (target: RevealTarget, announce: boolean) => Promise<unknown> | unknown;
  onPresent: (target: RevealTarget, announce: boolean) => Promise<unknown> | unknown;
  onClose: () => void;
}

export default function HandoutRevealDialog({ show, handout, people, channels, onReveal, onPresent, onClose }: Props) {
  return (
    <AudienceDialog
      show={show && !!handout}
      title={handout?.title || handout?.kind || ''}
      people={people}
      channels={channels}
      announce
      tag="handouts"
      onPick={onReveal}
      onPresent={onPresent}
      onClose={onClose}
    />
  );
}
